interface Props {
  number: number;
}

export const NumberBadge = ({ number }: Props) => {
  return (
    <div className="flex h-5 w-5 items-center justify-center rounded-[4px] bg-statusBlue-400 text-xs font-semibold text-gr-50">
      {number}
    </div>
  );
};
